import { useAuth } from '@inbody/keycloak';

// data 배럴은 api를 import한다(uploadCandidates) — api가 이 훅을 쓰므로 순환을 피해 파일 직접 참조
import {
  METADATA_ACCESS_ROLES,
  METADATA_DELETE_ROLES,
  METADATA_FIXED_OPTION_FIELDS,
  MetadataRole,
  MetadataRoleType,
} from '@/pages/v2/data/metadataRoles';

/**
 * 메타데이터 설정 권한 — Keycloak 클라이언트 role 기준(useAuth().checkRoles).
 *
 * - `canAccess`    : 설정 화면 접근 · 선택지 추가 · 수정 (ADMIN · METADATA_MANAGER · METADATA_EDITOR)
 * - `canDelete`    : 선택지 삭제 (ADMIN · METADATA_MANAGER)
 * - `canEditField` : 그 필드의 선택지를 바꿀 수 있는지 — 기밀등급처럼 서버에 고정된 필드는
 *                    아무도, 나머지(분류 포함)는 canAccess
 * - `role`         : 가진 role 중 가장 높은 것 (내 권한 표시용 · 없으면 null)
 *
 * UI 노출 게이트일 뿐이며, 실제 차단은 서버의 같은 role 검증이 담당한다(규칙 #5).
 */
export const useMetadataPermission = () => {
  const { checkRoles } = useAuth();
  const role: MetadataRoleType | null =
    [MetadataRole.ADMIN, MetadataRole.MANAGER, MetadataRole.EDITOR].find((r) =>
      checkRoles(r),
    ) ?? null;
  const canAccess = checkRoles(METADATA_ACCESS_ROLES);

  const canEditField = (field: string) =>
    !METADATA_FIXED_OPTION_FIELDS.includes(field) && canAccess;

  return {
    canAccess,
    canDelete: checkRoles(METADATA_DELETE_ROLES),
    canEditField,
    role,
  };
};
